export const EMAIL_REG_EXP = /^[A-Za-z0-9_]+[A-Za-z0-9_%-.+]+@[A-Za-z0-9.-]+\.[A-Za-z0-9]+$/
export const TargetFrame = {
  SameFrame: 'SameFrame',
  ParentFrame: 'ParentFrame',
  NewTab: 'NewTab',
}

export const ON_ACTION_CARD_SAVE_EVENT = 'onSaveData'
export const WEBPLAY_STORAGE_ENABLED = 'webplay-storage-enabled'
